(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class SvReviewsCarousel extends HTMLElement {
    connectedCallback() {
      // Un carrousel de photos vit à l'intérieur d'une carte du carrousel d'avis :
      // chaque composant ne prend que les éléments qui lui appartiennent en propre.
      const own = (element) => element.closest('sv-reviews-carousel') === this;

      this.track = Array.from(this.querySelectorAll('[data-sv-track]')).find(own);
      if (!this.track) return;

      this.cards = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-sv-dot]')).filter(own);
      this.prevButton = Array.from(this.querySelectorAll('[data-sv-prev]')).find(own) || null;
      this.nextButton = Array.from(this.querySelectorAll('[data-sv-next]')).find(own) || null;
      this.frame = null;

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.sync();
        });
      };

      // La piste des photos se cale sur la hauteur de la photo affichee, pas sur
      // la plus grande du lot. Observer les photos suffit : leur hauteur bouge au
      // chargement de l'image et a chaque changement de largeur.
      this.fitsHeight = this.hasAttribute('data-sv-fit-height');
      if (this.fitsHeight && 'ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.fitHeight());
        this.cards.forEach((card) => this.observer.observe(card));
      }

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.move(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.move(1));
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.scrollToIndex(index));
      });

      this.sync();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.observer) this.observer.disconnect();
    }

    fitHeight() {
      const card = this.cards[this.currentIndex];
      if (!card) return;
      const height = card.getBoundingClientRect().height;
      if (height > 0) this.track.style.blockSize = `${height}px`;
    }

    get currentIndex() {
      const position = this.track.scrollLeft;
      let closest = 0;
      let smallest = Infinity;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - position);
        if (distance < smallest) {
          smallest = distance;
          closest = index;
        }
      });

      return closest;
    }

    move(direction) {
      this.scrollToIndex(this.currentIndex + direction);
    }

    scrollToIndex(index) {
      const bounded = Math.max(0, Math.min(index, this.cards.length - 1));
      const card = this.cards[bounded];
      if (!card) return;
      this.track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
    }

    sync() {
      const index = this.currentIndex;

      this.dots.forEach((dot, position) => {
        const active = position === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 1;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll;

      if (this.fitsHeight) this.fitHeight();
    }
  }

  if (!customElements.get('sv-reviews-carousel')) {
    customElements.define('sv-reviews-carousel', SvReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
